import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import { jsonParse, localToUTC } from 'src/app/controls/functions/shared-functions';
import { map } from 'rxjs/operators';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';

var crypto = require('crypto');
var forge = require('node-forge');
forge.options.usePureJavaScript = true;
const pako = require('pako');
var algorithm = 'aes-256-cbc';
var iv = "1234567891234567";

@Injectable({
  providedIn: 'root'
})
export class ProfileSettingsService {
  access_rights = new Object()
  private userData = new BehaviorSubject(null);
  checkUser$ = this.userData.asObservable();
  private accessData = new BehaviorSubject(null);
  private sidebarData = new BehaviorSubject(null);
  private jobList = new BehaviorSubject(null);
  checkAccessData$ = this.userData.asObservable();
  access_right_change: Subject<object> = new Subject<object>();
  private country_master = new BehaviorSubject(null);
  firebase_messaging: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private http: HttpClient) {

    try {
      let res = jsonParse(localStorage.getItem('settings'))
      if (res) {
        res['isSession'] = 1;
        this.country_master.next(res);
      }
    }
    catch (err) {
      console.log(err)
    }

  }
  api_url: string = environment.SERVER_URL + 'User/';

  getProfileDetails() {
    return this.http.get(this.api_url + 'ProfileMaster?lng_id=1')
  }
  saveProfileDetails(profile_settings) {
    return this.http.post(this.api_url + 'UpdateProfile?lng_id=1', profile_settings);
  }
  getAccessRights() {
    return this.http.get(environment.SERVER_URL + 'NotifList/Details', { params: { origin: 'localhost' } })
  }
  setaccess_right(value) {
    try {
      this.access_right_change.next(this.access_rights = JSON.parse(value)
      );
      this.createAccess(this.access_right_change);
    }
    catch {

      this.access_right_change.next(
        this.access_rights = (value)
      );
      this.createAccess(this.access_right_change);



    }
    this.getAccessRightObj


  }
  // getAccessRightObj() {
  //   return (this.access_rights)
  // }
  getAccessRightObj(): Observable<any> {
    return this.access_right_change.asObservable();
  }

  createData(data: any) {
    this.userData.next(data);
  }
  setJobList(list) {
    console.log(list)
    this.jobList.next(list)
  }
  getStoredJobList(): Observable<any> {
    console.log(this.jobList)
    return this.jobList.asObservable();
  }
  createAccess(data: any) {
    this.accessData.next(data);
  }
  invalid_field = new Subject();
  triggerInvalidField(item) {
    this.invalid_field.next(item);
  }


  getInvalidField(): Observable<any> {
    return this.invalid_field.asObservable();
  }

  getSidebarDetails() {
    return this.sidebarData.asObservable();
  }
  setSidebarData(data) {
    this.sidebarData.next(data);
  }
  searchMaster(req, apiName, storePropertyName) {
    return this.http.post(environment.SERVER_URL + 'icrweb/home/' + apiName, req, {
      headers: {
        header_type: '2'
      }
    }).pipe(map(res => {
      console.log(res);
      let skillMaster: any = {}
      if (res && res['data'] && res['data'].list) {
        skillMaster['list'] = res['data'].list;
        let date = localToUTC(new Date());
        skillMaster['lastTimeStamp'] = date;
        localStorage.setItem(storePropertyName, JSON.stringify(skillMaster))
        return res;
      }
    }))
  }

  countryMaster(params?) {
    let shortCode = localStorage.getItem('sellerShortCode')
    if (!params) {
      try {
        let ip_details = getIP()
        params = {}
        params['ip'] = ip_details['ip'];
        if (shortCode) {
          params['sellerShortCode'] = shortCode;
        }
      }
      catch (err) {

      }
    }
    else {
      if (shortCode) {
        params['sellerShortCode'] = shortCode;
      }
    }
    return this.http.get(environment.SERVER_URL + 'icrweb/countryMaster', { params: params, headers: { header_type: '2' } }).pipe(map(res => {
      console.log(res);
      if (res) {
        this.country_master.next(res);
        localStorage.setItem('settings', JSON.stringify(res))
      }
      if (res && res['data']) {
        localStorage.setItem('sellerShortCode', res['data'].sellerShortCode)
      }
      return res
    }))

  }

  loadDefaultSettings(): Observable<any> {
    return this.country_master.asObservable();
  }

  searchMasterWithTimestamp(req, apiName, storePropertyName, id_property) {
    let skillMaster: any = {};
    try {
      skillMaster = jsonParse(localStorage.getItem(storePropertyName));
      if (skillMaster && skillMaster.lastTimeStamp) {
        if (req) {
          req['lastTimeStamp'] = skillMaster.lastTimeStamp;
        }
        else {
          req = {
            lastTimeStamp: skillMaster.lastTimeStamp,
            type: 0
          }
        }
      }
    }
    catch (err) {
      console.log(err)
    }
    return this.http.post(environment.SERVER_URL + 'icrweb/home/' + apiName, req, {
      headers: {
        header_type: '2'
      }
    }).pipe(
      map(res => {
        let date = localToUTC(new Date());
        if (skillMaster) {
          skillMaster['lastTimeStamp'] = date;
        }
        else {
          skillMaster = {}
          skillMaster['lastTimeStamp'] = date;
        }
        if (req['lastTimeStamp']) {
          if (skillMaster && skillMaster.list && skillMaster.list.length) {
            if (res && res['data'] && res['data'].list && res['data'].list.length) {
              res['data'].list.forEach(newSkill => {
                let index = skillMaster['list'].findIndex(data => data[id_property] == newSkill[id_property]);
                if (index > -1) {
                  skillMaster['list'][index] = newSkill;
                }
                else {
                  skillMaster['list'].push(newSkill)
                }
              })
              res['data'].list = skillMaster['list'];
              localStorage.setItem(storePropertyName, JSON.stringify(skillMaster))
              return res;
            }
            else {

              return {
                data: {
                  list: skillMaster.list
                }
              }
            }
          }
          else {
            skillMaster['list'] = res && res['data'] && res['data'].list;
            localStorage.setItem(storePropertyName, JSON.stringify(skillMaster))
            return res;
          }

        }
        else {
          skillMaster['list'] = res && res['data'] && res['data'].list;
          localStorage.setItem(storePropertyName, JSON.stringify(skillMaster))
          return res;
        }
      }, err => {
        return {
          data: {
            list: skillMaster.list
          }
        };
      })
    );
  }

  getV3(secretKey, data) {
    try {
      var buffer = Buffer.from(data, 'base64')
      var encPassword = secretKey;
      var password = crypto.createHash("sha256").update(encPassword).digest(); //create password with secret key
      var decipher = crypto.createDecipheriv(algorithm, password, iv);
      var dec = Buffer.concat([decipher.update(buffer), decipher.final()]);
      var decodedData = pako.ungzip(dec);
      var textDecoder = new TextDecoder();
      var dataObject = JSON.parse(textDecoder.decode(decodedData));
      return dataObject
    }
    catch (err) {
      console.log(err);
      return data;
    }

  }

  setFirebaseMessage(obj) {
    this.firebase_messaging.next(obj);
  }
  getFirebaseMessage() {
    return this.firebase_messaging.asObservable();
  }
  saveFCMKey(request) {
    return this.http.post(environment.SERVER_URL + 'icrweb/home/save_fcm_token', request, {
      headers: {
        header_type: '2'
      }
    });
  }

}
